import React from 'react';
import { FormattedHTMLMessage, injectIntl, InjectedIntl, FormattedMessage } from 'react-intl';

import {
    VerificationService,
    getLogoUrl,
    LogoComponent,
    PoweredByComponent
 } from '@sheerid/jslib';

interface StepSuccessProps {
    verificationService: VerificationService;
    intl: InjectedIntl;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccess = ({ verificationService, intl }: StepSuccessProps) => {
    const hasLogo = getLogoUrl(verificationService.programTheme) ? true : false;
    const redirectDestination = intl.messages['step.success.redirectUrl'];
    const showRedirect = Boolean(redirectDestination);

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo ?
                        <LogoComponent verificationService={verificationService} />
                        :
                        <img
                            className="sid-l-lead-image"
                            alt="design element"
                            src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                        />
                    }
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Your account has been upadet to reflect your teacher status.`
                    } />
                </div>
            </div>

            {
                (showRedirect) ?
                    <div className="sid-submit sid-l-space-top-md">
                        <button
                            onClick={() => redirect(redirectDestination)}
                            className="sid-btn sid-btn--dark"
                        >
                            <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="CONTINUE TO ACCOUNT" />
                        </button>
                    </div> : ''
            }

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedMessage id="companyName" defaultMessage="{Company}">
                    {companyName => (
                        <FormattedHTMLMessage id="step.success.verificationOnly"
                            defaultMessage={`
                                SheerID handles verification only.
                                Now that you've been approved, please direct all questions about the
                                promotion terms to Sonic customer service.
                            `}
                            values={{ companyName }}
                        />
                    )}
                </FormattedMessage>
            </div>
            <div className="sid-footer__two">
                    <PoweredByComponent verificationService={verificationService} />
                </div>
        </div>
    );
};


export const StepSuccessComponent = injectIntl(StepSuccess);

